import { Notification, NotificationStep, NotificationType, ProcessDocumentNotificationStep } from '@dynamik/common/clients/notification-clients';

export class NotificationStepValueConverter {
  toView(ns: NotificationStep, n: Notification): string {
    switch (n.type) {
      case NotificationType.ProcessDocument:
        // 1. Try to get the friendly name from the enum
        const stepIndex = Number(ns.step);
        const enumName = ProcessDocumentNotificationStep[stepIndex];

        // 2. Priority: 1. Manual name, 2. Formatted Enum name, 3. Raw value
        const rawLabel = ns.stepName || enumName;

        // 3. ONLY call replace if rawLabel is actually a string
        if (typeof rawLabel === 'string') {
          return rawLabel.replace(/([a-z])([A-Z])/g, '$1 $2').trim();
        }

        // 4. Fallback to the number itself (as a string) if all else fails
        return ns.step?.toString();
      case NotificationType.SendVouchersToGl:
        return ns.stepName;
      case NotificationType.ProcessVouchers:
        return ns.stepName;
      default: return ns.stepName;
    }
  }
}
